import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        font-family: var(--sgdf-font-sans);
        color: var(--sgdf-color-default);
    }

    .container {
        display: grid;
        row-gap: var(--sgdf-spacing-medium);
    }

    .intro .detail {
        color: var(--sgdf-color-light);
    }

    .comment-form {
        padding-top: var(--sgdf-spacing-small);
        display: grid;
        grid-row-gap: var(--sgdf-spacing-small);
        grid-column-gap: var(--sgdf-spacing-small);
    }

    @media screen and (max-width: 700px) {
        .comment-form {
            grid-template-columns: 1fr;
            grid-template-rows: auto;
            grid-template-areas:
                'date .'
                'help-date help-date'
                'type .'
                'text text'
                'tag tag'
                'footer footer';
        }
    }

    @media screen and (min-width: 700px) {
        .comment-form {
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: auto;
            grid-template-areas:
                'date date date date'
                'type type type type'
                'text text text text'
                'tag tag tag tag'
                '. . . footer';
        }
    }

    .date {
        grid-area: date;
        width: 100%;
        display: grid;
        gap: var(--sgdf-spacing-small);
        grid-template-columns: auto 1fr;
    }

    .text {
        grid-area: text;
    }

    .obs-type {
        grid-area: type;
    }

    .tag-picker {
        grid-area: tag;
    }

    .footer {
        grid-area: footer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--sgdf-spacing-small);
    }

    .error:not([disabled])::part(label),
    .error:not([disabled])::part(help-text) {
        color: var(--sl-color-danger-600);
    }

    .error:not([disabled])::part(control),
    .error:not([disabled])::part(base) {
        border-color: var(--sl-color-danger-500);
    }
`;
//# sourceMappingURL=comment-form.styles.js.map